import { Injectable } from '@angular/core';
import * as formdatajson from '../../assets/data/formData.json';

@Injectable({
  providedIn: 'root'
})
export class ReferralFormService {

  formData: any;

  constructor() { }

  public getFormLoadJSON(): any {
    let formdata = Object.assign({}, formdatajson as any);
    let result = JSON.parse(JSON.stringify(formdata));
    return result;
  }
}
